import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { useEffect } from "react";
import mainStore from "./store/store";
import analytics, { initAnalytics } from "./utils/analytics";
import { setupPerformanceMonitoring, preloadCriticalResources } from "./utils/performanceUtils";
import WhatsAppContactButton from "./components/WhatsAppContactButton";

function App() {
  const { getAllCars } = mainStore();

  useEffect(() => {
    // Get today's date in YYYY-MM-DD format without moment.js
    const today = new Date().toISOString().split('T')[0];
    
    getAllCars(today, today);
    
    // Initialize analytics tracking
    initAnalytics();
    
    // Initialize performance monitoring
    setupPerformanceMonitoring();
    
    // Preload critical resources
    preloadCriticalResources([
      { href: '/css/bootstrap.min.css', as: 'style' },
      { href: '/css/custom.css', as: 'style' }
    ]);
    
    // Track errors globally
    window.addEventListener('error', (event) => {
      analytics.trackError('javascript_error', event.message, {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno
      });
    });
    
    // Track unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      analytics.trackError('unhandled_rejection', event.reason?.message || 'Unknown error', {
        reason: event.reason
      });
    });
  }, []);

  return (
    <Router>
      <AppRoutes />
      <WhatsAppContactButton />
    </Router>
  );
}

export default App;
